// src/services/signedDocumentService.js
//
// Ciclo de firma de los documentos del reclamo que no son por cheque:
// LOR (contrato, firma el cliente) y SPOL (firma y notariza el cliente).
// Mismo patrón que el Closing (closingService.js):
//   generated → sent (entregado al cliente) → signed (PDF firmado
//   respaldado en Hostinger).
//
// Se guarda en el reclamo: claimRecords/{id}.signedDocuments.{lor|spol}
// (updateClaimRecord no lo toca: solo escribe los campos del formulario).
// El PDF firmado va al almacenamiento de adjuntos del reclamo (backup.php
// tipo 'attachment'), así el PA dueño del reclamo también puede abrirlo.
import { auth, db } from '../firebase/config';
import { doc, Timestamp, updateDoc } from 'firebase/firestore';
import { uploadBackup } from './backupService';

export const SIGNABLE_DOCUMENTS = ['lor', 'spol'];

const currentEmail = () => auth.currentUser?.email || '';

const write = async (claimRecord, docType, fields) => {
  if (!SIGNABLE_DOCUMENTS.includes(docType)) throw new Error(`Unknown document: ${docType}`);
  const next = { ...(claimRecord.signedDocuments?.[docType] || {}), ...fields, updatedAt: Timestamp.now(), updatedBy: currentEmail() };
  await updateDoc(doc(db, 'claimRecords', claimRecord.id), { [`signedDocuments.${docType}`]: next, updatedAt: Timestamp.now() });
  // Para reflejarlo en la ficha sin recargar (merge en ClaimDetailPage).
  return { signedDocuments: { ...(claimRecord.signedDocuments || {}), [docType]: next } };
};

// Se descargó el PDF: solo marca "generado" si todavía no avanzó.
export const markDocumentGenerated = async (claimRecord, docType) => {
  const status = claimRecord.signedDocuments?.[docType]?.status;
  return status ? null : write(claimRecord, docType, { status: 'generated', generatedAt: Timestamp.now() });
};

export const markDocumentSent = (claimRecord, docType, { sentDate, signatureUrl }) =>
  write(claimRecord, docType, { status: 'sent', sentDate: sentDate || '', signatureUrl: (signatureUrl || '').trim() });

export const attachSignedDocument = async (claimRecord, docType, file, signedDate) => {
  const backup = await uploadBackup({ file, claimId: claimRecord.id, invoiceNumber: '', type: 'attachment' });
  return write(claimRecord, docType, {
    status: 'signed',
    signedDate: signedDate || '',
    signedPdf: {
      storageKey: backup.storageKey,
      name: backup.name || file.name,
      mimeType: backup.mimeType || file.type,
      size: backup.size || file.size,
      uploadedAt: Timestamp.now(),
      uploadedBy: backup.uploadedBy || currentEmail()
    }
  });
};
